import React from "react";
import { Container, Typography } from "@mui/material";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import MissionBanner from "../../assets/Mission.jpg";
import PageTitle from "../../Components/PageTitle";

const Mission = () => {
  return (
    <>
      <Navbar />

      <PageTitle
        title="Mission - Shree Mangalam School"
        description="The mission of Shree Mangalam School is to nurture young minds through quality education, moral values, and focused preparation for RIMC, Sainik School, and Military School entrance exams."
        url="/mission"
        keywords="school mission, Shree Manglam mission, RIMC preparation, sainik school coaching goal, military school values, quality education"
      />

      <Header image={MissionBanner} alt={"Mission"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Mission
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, our mission is to build a
          nurturing, inclusive, and empowering educational environment where
          every student feels seen, heard, and valued. We strive to cultivate
          independence, confidence, and a lifelong love for learning, enabling
          our students to thrive both personally and academically.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We are committed to fostering open communication, mutual respect, and
          meaningful collaboration among students, parents, educators, and the
          broader community. By promoting intellectual curiosity and social
          growth, we aim to shape well-rounded individuals who are prepared to
          face the challenges of an evolving world with courage, compassion, and
          conviction.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our school is a safe haven where students are encouraged to explore
          their identities, clarify their values, and develop a strong moral
          compass. We recognize and actively respond to the individual needs and
          diverse backgrounds of our students, while also challenging
          prejudices—both visible and hidden—based on gender, religion, caste,
          economic status, or ability.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Through a dynamic curriculum and student-centered approach, we are
          dedicated to preparing every learner for a future of purpose and
          passion. We emphasize career readiness, civic responsibility, social
          awareness, and personal growth, ensuring our students emerge as
          responsible citizens and proud contributors to society.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we honour our legacy of excellence
          and embrace the promise of tomorrow with integrity, innovation, and
          pride.
        </Typography>
      </Container>

      <Footer />
    </>
  );
};

export default Mission;
